import { forwardRef } from 'react';
import PropTypes from 'prop-types';
// import customPropTypes from 'lib/customPropTypes';
// import styled from 'styled-components';
import globals from 'styles/globals';

import DeprecatedButton, { ButtonPropTypes } from '../index';

const DarkButton = ({ forwardedRef, baseStyle, hoverStyle, disabledStyle, ...buttonProps }) => {
  const primaryBaseStyle = {
    fontColor: globals.colors.white,
    bgColor: globals.colors.charcoal,
    borderColor: globals.colors.charcoal,
    ...baseStyle,
  };

  const primaryHoverStyle = {
    bgColor: globals.colors.charcoal,
    borderColor: globals.colors.charcoal,
    ...hoverStyle,
  };

  const primaryDisabledStyle = {
    bgColor: globals.colors.charcoal,
    borderColor: globals.colors.charcoal,
    ...disabledStyle,
  };

  const computedProps = {
    baseStyle: primaryBaseStyle,
    hoverStyle: primaryHoverStyle,
    disabledStyle: primaryDisabledStyle,
    spinnerInnerColor: globals.colors.fontLight,
    spinnerOuterColor: globals.colors.mediumGrey,
    ...buttonProps,
  };

  return <DeprecatedButton ref={forwardedRef} {...computedProps} />;
};

DarkButton.propTypes = {
  baseStyle: ButtonPropTypes.style,
  hoverStyle: ButtonPropTypes.style,
  disabledStyle: ButtonPropTypes.style,
  // eslint-disable-next-line react/forbid-prop-types
  forwardedRef: PropTypes.any,
};

DarkButton.defaultProps = {
  baseStyle: {},
  hoverStyle: {},
  disabledStyle: {},
  forwardedRef: undefined,
};

export default forwardRef((props, ref) => <DarkButton {...props} forwardedRef={ref} />);
